import config from '@/api/config'

let subUrl = '/auth/'

export default {
  expiredToken: {
    url: function () {
      return config.baseUrl + config.version2 + subUrl + 'expired'
    }
  }
}
